import { render } from "./Organizations.vue?vue&type=template&id=a68c19ee"
import script from "./Organizations.vue?vue&type=script&lang=js"
export * from "./Organizations.vue?vue&type=script&lang=js"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__